import { gql } from 'apollo-boost';

const getSelfieCheckUpdate = gql`
  mutation getSelfieCheckUpdate($request : GetSelfieCheckUpdateRequestType!) {
    getSelfieCheckUpdate(request: $request) {
      selfieCaptured
    }
  }
`;

export default getSelfieCheckUpdate;